// plugins/axios.js
import axios from 'axios';
import store from '../store/Index.js';
import router from '../router/router.js';
import { ensureRefresh, hasValidRefreshToken } from './refreshManager.js';

// Inject Bearer
axios.interceptors.request.use((config) => {
    const token = store.getters.get_token;
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Refresh auto sur 401 (dédupliqué)
axios.interceptors.response.use(
    (res) => res,
    async (error) => {
        const originalRequest = error?.config;
        const status = error?.response?.status;

        if (!originalRequest) return Promise.reject(error);

        // Ne rafraîchis pas... le refresh lui-même
        if (String(originalRequest.url).includes('/auth/refresh/')) {
            return Promise.reject(error);
        }

        if (status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            if (!hasValidRefreshToken()) {
                await store.dispatch('logout');
                const cur = router.currentRoute.value;
                if (cur.path !== '/welcome') {
                    router.replace({ path: '/welcome', query: { redirect: cur.fullPath } });
                }
                return Promise.reject(error);
            }

            try {
                await ensureRefresh(store); // même promesse que le router
                if (!store.getters.isAuthenticated) throw new Error('Refresh failed');

                // Rejouer la requête avec le nouveau token
                const newToken = store.getters.get_token;
                originalRequest.headers = originalRequest.headers || {};
                originalRequest.headers.Authorization = `Bearer ${newToken}`;
                return axios(originalRequest);
            } catch (e) {
                await store.dispatch('logout');
                const cur = router.currentRoute.value;
                if (cur.path !== '/welcome') {
                    router.replace({ path: '/welcome', query: { redirect: cur.fullPath } });
                }
                return Promise.reject(e);
            }
        }

        return Promise.reject(error);
    }
);

export default axios;